module.exports = __webpack_public_path__ + "media/images/instagram-f2e3d0fb4fa12e9796d408684d94fc72.svg";